(function () {
  var SIZE = 'Veličina', COLOR = 'Boja';
  // null = the shopper must pick for themselves (Milan's call, 2026-08-02).
  // Set either to a swatch/size label (e.g. 'Bela', 'M') to preselect it again.
  var DEFAULT_COLOR = null, DEFAULT_SIZE = null;
  var CHOOSE_SIZE = 'Izaberite veličinu', CHOOSE_COLOR = 'Izaberite boju';
  var st = {};
  var origPrice = {};

  function piOf(n) { return n && n.closest ? n.closest('product-info') : null; }
  function sid(pi) { return pi.dataset.section || pi.dataset.originalSection; }
  function state(id) { if (!st[id]) st[id] = { color: false, size: false, userColor: false, locked: false, defaultColor: null }; return st[id]; }

  function fieldsetByLegend(pi, name) {
    var els = pi.querySelectorAll('variant-selects .product-form__input');
    for (var i = 0; i < els.length; i++) {
      var lg = els[i].querySelector('legend, .form__label');
      if (lg && lg.textContent.trim().indexOf(name) === 0) return els[i];
    }
    return null;
  }
  function imgMap(pi) {
    var s = pi.querySelector('[data-velicina-images]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function setMedia(pi, mid) {
    if (!mid) return false;
    var g = pi.querySelector('media-gallery');
    if (!g || typeof g.setActiveMedia !== 'function') return false;
    try { g.setActiveMedia(sid(pi) + '-' + mid, false); return true; } catch (e) { return false; }
  }

  // Force the gallery to the product's featured (plant) image until a colour is chosen.
  function forceFeatured(pi) {
    var s = state(sid(pi));
    if (s.userColor) return;
    var m = imgMap(pi);
    if (m && m.neutral) setMedia(pi, m.neutral);
  }
  function forceFeaturedAll() {
    var nodes = document.querySelectorAll('product-info');
    for (var i = 0; i < nodes.length; i++) forceFeatured(nodes[i]);
  }

  function apply(pi) {
    if (!pi) return;
    var sizeFs = fieldsetByLegend(pi, SIZE);
    if (!sizeFs) return;
    var id = sid(pi); var s = state(id);
    var colorFs = fieldsetByLegend(pi, COLOR);
    var submit = pi.querySelector('.product-form__submit');
    var payment = pi.querySelector('.shopify-payment-button');
    var dims = pi.querySelector('[data-velicina-dims]');
    var sizeLeg = sizeFs.querySelector('[data-selected-value]');
    var colorLeg = colorFs ? colorFs.querySelector('[data-selected-value]') : null;
    var priceWrap = pi.querySelector('#price-' + id);
    var vs = pi.querySelector('variant-selects');
    var from = vs ? vs.getAttribute('data-price-from') : null;

    if (colorFs) {
      if (s.color) { colorFs.classList.remove('velicina-unset'); }
      else { colorFs.classList.add('velicina-unset'); if (colorLeg && colorLeg.textContent.trim() !== CHOOSE_COLOR) colorLeg.textContent = CHOOSE_COLOR; }
    }

    if (s.size) {
      sizeFs.classList.remove('velicina-unset');
      if (dims) dims.hidden = false;
      if (priceWrap && Object.prototype.hasOwnProperty.call(origPrice, id)) { priceWrap.innerHTML = origPrice[id]; delete origPrice[id]; }
    } else {
      sizeFs.classList.add('velicina-unset');
      if (sizeLeg && sizeLeg.textContent.trim() !== CHOOSE_SIZE) sizeLeg.textContent = CHOOSE_SIZE;
      if (dims) dims.hidden = true;
      if (priceWrap && from) {
        if (!Object.prototype.hasOwnProperty.call(origPrice, id)) origPrice[id] = priceWrap.innerHTML;
        var reg = priceWrap.querySelector('.price-item--regular') || priceWrap.querySelector('.price-item');
        if (reg && reg.textContent.indexOf('Od') === -1) reg.textContent = 'Od ' + from;
      }
    }

    var ready = s.color && s.size;
    if (submit && !ready) {
      submit.setAttribute('disabled', 'disabled');
      var sp = submit.querySelector('span');
      var msg = !s.size ? CHOOSE_SIZE : CHOOSE_COLOR;
      if (sp && sp.textContent.trim() !== msg) sp.textContent = msg;
    }
    if (payment) payment.style.display = ready ? '' : 'none';
  }

  function applyAll() {
    var nodes = document.querySelectorAll('product-info');
    for (var i = 0; i < nodes.length; i++) apply(nodes[i]);
  }

  function onPick(target) {
    var pi = piOf(target); if (!pi) return; var id = sid(pi);
    state(id).locked = true;
    var colorFs = fieldsetByLegend(pi, COLOR), sizeFs = fieldsetByLegend(pi, SIZE);
    if (sizeFs && sizeFs.contains(target)) state(id).size = true;
    if (colorFs && colorFs.contains(target)) {
      state(id).color = true;
      state(id).userColor = true;
      var m = imgMap(pi);
      if (m && m.colors && m.colors[target.value]) setMedia(pi, m.colors[target.value]);
    }
    setTimeout(applyAll, 0);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') e.target.dataset.velicinaChanged = '1';
    if (!e.isTrusted) return;
    if (e.target && e.target.type === 'radio') onPick(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var n = e.target; if (!n || !n.closest) return;
    var hit = n.closest('.product-form__input--pill label, .product-form__input--pill input[type="radio"], .product-form__input--swatch label, .product-form__input--swatch input[type="radio"]');
    if (!hit) return;
    var radio = hit.tagName === 'LABEL' ? (hit.control || document.getElementById(hit.getAttribute('for'))) : hit;
    if (radio && radio.type === 'radio') {
      onPick(radio);
      // Dawn renders the first variant's radios pre-checked; we only mask them
      // visually. Clicking an already-checked radio fires no 'change' event, so
      // Dawn's VariantSelects never runs, the section is never re-rendered, and
      // the buy button stays disabled ("Izaberite veličinu") even though the
      // swatch looks selected. If no real 'change' follows this click, dispatch
      // one ourselves so Dawn syncs (our own change listener ignores it via
      // e.isTrusted, so onPick doesn't run twice).
      if (radio.checked) {
        delete radio.dataset.velicinaChanged;
        setTimeout(function () {
          if (radio.dataset.velicinaChanged) return;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      }
    }
  }, true);


  function pickRadio(fs, value) {
    if (!fs) return false;
    var radios = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value && !radios[i].classList.contains('disabled')) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }
  function preselectDefaults() {
    if (!DEFAULT_COLOR && !DEFAULT_SIZE) return;
    var nodes = document.querySelectorAll('product-info');
    for (var i = 0; i < nodes.length; i++) {
      var pi = nodes[i]; var id = sid(pi); var s = state(id);
      if (s.color || s.size) continue;
      var okC = DEFAULT_COLOR ? pickRadio(fieldsetByLegend(pi, COLOR), DEFAULT_COLOR) : false;
      var okS = DEFAULT_SIZE ? pickRadio(fieldsetByLegend(pi, SIZE), DEFAULT_SIZE) : false;
      if (okC) {
        s.color = true;
        // Treat the preselected swatch exactly like a shopper's own click, so the
        // gallery shows that colour. Without this the picker reads "Bela" while the
        // lifestyle shot (a black pot) stays on screen — a visible contradiction.
        s.userColor = true;
        s.defaultColor = DEFAULT_COLOR;
      }
      if (okS) s.size = true;
    }
  }
  // Shows the preselected colour's photo. Skipped the moment the shopper touches
  // the picker (locked), so a late retry can never yank the gallery back.
  function applyDefaultColorMedia(pi) {
    var s = state(sid(pi));
    if (!s.defaultColor || s.locked) return;
    var m = imgMap(pi);
    if (m && m.colors && m.colors[s.defaultColor]) setMedia(pi, m.colors[s.defaultColor]);
  }
  function syncGalleryAll() {
    var nodes = document.querySelectorAll('product-info');
    for (var i = 0; i < nodes.length; i++) {
      forceFeatured(nodes[i]);        // no-op once a colour is set
      applyDefaultColorMedia(nodes[i]);
    }
  }

  function boot() {
    preselectDefaults();
    applyAll();
    syncGalleryAll();
    // Gallery custom element may not be upgraded at DOMContentLoaded; retry when ready.
    try {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('media-gallery').then(function () {
          syncGalleryAll();
          setTimeout(syncGalleryAll, 60);
          setTimeout(syncGalleryAll, 300);
        });
      }
    } catch (e) {}
    window.addEventListener('load', syncGalleryAll);
    try {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(applyAll, 0); });
      }
    } catch (e) {}
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
